import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography
} from "@mui/material";

const AlertDialog = ({
  title,
  description,
  buttonTitle,
  onClose,
  onButtonAction,
  addCancel = false,
  dismissable = true,
  showAlert,
  isLoading = false
}) => {
  return (
    <Dialog open={showAlert} onClose={dismissable ? onClose : undefined}>
      <DialogTitle>
        <Typography>{title}</Typography>
      </DialogTitle>
      <DialogContent>
        <Typography>{description}</Typography>
      </DialogContent>
      <DialogActions>
        {addCancel && (
          <Button onClick={onClose} color="secondary">
            Cancel
          </Button>
        )}
        <Button
          onClick={onButtonAction}
          color="primary"
          disabled={isLoading}
          variant="contained"
        >
          {isLoading ? "Loading..." : buttonTitle}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AlertDialog;
